<template>
  <div>
    <particlesHeader v-if="PageName" :Title="PageName" :Size="13" />
    <div class="content-section" v-if="Content">
      <iframe :src="Content" :onload="loadEvent" @resize="HandleResize"></iframe>
    </div>
  </div>
</template>

<script>
import particlesHeader from "../components/particlesHeader";
const TheatorPagesPath = "/dynamicPages/";
export default {
  components: {
    particlesHeader
  },
  data: function() {
    return {
      PageName: null,
      Content: null,
      loadEvent:
        "this.style.height=(this.contentWindow.document.body.scrollHeight+" +
        (this.$isMobile() ? "250" : "500") +
        ")+'px';"
    };
  },

  methods: {
    HandleResize(e) {
      var frame = e.target;
      var height = frame.getBoundingClientRect().height;
      frame.style.height = height + 150 + "px";
    }
  },
  mounted: function() {
    let pageName = this.$route.params.pageName;
    if (!pageName) {
      this.$router.push("/404");
      return;
    }
    this.PageName = pageName;
  },

  created: function() {
    let pageName = this.$route.params.pageName;
    if (!pageName) {
      this.$router.push("/404");
      return;
    }
    this.Content = TheatorPagesPath + `/pages/${pageName}.html`;
  }
};
</script>

<style>
iframe {
  height: 774px;
  width: 100%;
  border: 0px solid red;
}
</style>